import { render, staticRenderFns } from "./score-block.vue?vue&type=template&id=06f59491&scoped=true&"
import script from "./score-block.vue?vue&type=script&lang=js&"
export * from "./score-block.vue?vue&type=script&lang=js&"
import style0 from "./score-block.vue?vue&type=style&index=0&id=06f59491&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f59491",
  null
  
)

export default component.exports